var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.414
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.117 0H.883A.883.883 0 000 .883v14.234c0 .488.395.883.883.883h7.663V9.804H6.46V7.39h2.086V5.607c0-2.066 1.262-3.19 3.106-3.19.883 0 1.642.064 1.863.094v2.16h-1.28c-1 0-1.195.48-1.195 1.18v1.54h2.39l-.31 2.42h-2.08V16h4.077a.883.883 0 00.883-.883V.883A.883.883 0 0015.117 0",
    fillRule: "nonzero"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxLjQxNCI+PHBhdGggZD0iTTE1LjExNyAwSC44ODNDLjM5NSAwIDAgLjM5NSAwIC44ODN2MTQuMjM0YzAgLjQ4OC4zOTUuODgzLjg4My44ODNoNy42NjNWOS44MDRINi40NlY3LjM5aDIuMDg2VjUuNjA3YzAtMi4wNjYgMS4yNjItMy4xOSAzLjEwNi0zLjE5Ljg4MyAwIDEuNjQyLjA2NCAxLjg2My4wOTR2Mi4xNmgtMS4yOGMtMSAwLTEuMTk1LjQ4LTEuMTk1IDEuMTh2MS41NGgyLjM5bC0uMzEgMi40MmgtMi4wOFYxNmg0LjA3N2MuNDg4IDAgLjg4My0uMzk1Ljg4My0uODgzVi44ODNDMTYgLjM5NSAxNS42MDUgMCAxNS4xMTcgMCIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9zdmc+";
export { SvgFacebook as ReactComponent };